export const NotificationType = {
    OVERALL_WEIGHTAGE_EXCEEDED: "OVERALL_WEIGHTAGE_EXCEEDED",
    WEIGHTAGE_UPDATE_SUCCESS: "WEIGHTAGE_UPDATE_SUCCESS",
    BAND_VALUE_VALIDATION_ERROR: "BAND_VALUE_VALIDATION_ERROR",
    BAND_UPDATE_SUCCESS: "BAND_UPDATE_SUCCESS",
    HTTP_ACTION_ERROR: "HTTP_ACTION_ERROR"
}